<template>
  <div class="app-wrapper" :class="{hideSidebar:!menusOpened}">
    <nav-bar></nav-bar>
    <div class="main-container">
      <side-bar class="sidebar-container" :menus="menus" :opened="menusOpened"></side-bar>
      <app-main></app-main>
    </div>
  </div>
</template>

<script>
import { AppMain, SideBar, NavBar } from '@/views/layout'
import { mapGetters } from 'vuex'

export default {
  name: 'Home',
  data () {
    return {
    }
  },
  components: {
    SideBar,
    AppMain,
    NavBar
  },
  computed: {
    ...mapGetters([
      'menus',
      'menusOpened'
    ])
  }
}
</script>
<style lang="scss" scoped>
@import "src/styles/mixin.scss";
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
  &.hideSidebar {
    .sidebar-container {
      width: 64px;
      overflow: inherit;
    }
    .main-container {
      margin-left: 64px;
    }
  }
  .sidebar-container {
    transition: width 0.28s ease-out;
    width: 200px;
    height: 100%;
    position: fixed;
    top: 50px;
    bottom: 0;
    left: 0;
    z-index: 1001;
    overflow-y: auto;
    padding-bottom: 50px;
    &::-webkit-scrollbar {
      display: none
    }
  }
  .main-container {
    position: relative;
    min-height: 100%;
    transition: margin-left 0.28s ease-out;
    margin-left: 200px;
  }
}
</style>




// WEBPACK FOOTER //
// Layout.vue?76451b5c